<template>
	<div>
		<Hero />
		<About />
		<Services />
		<Faq />
		<!-- <Testimonials /> -->
	</div>
</template>

<script>
// @ is an alias to /src

import Hero from "@/sections/HeroSection.vue";
import About from "@/sections/AboutSection.vue";
import Services from "@/sections/ServicesSection.vue";
import Faq from "@/sections/FaqSection.vue";
// import Testimonials from "@/sections/TestimonialsSection.vue";

export default {
	name: "Home",
	components: {
		Hero,
		About,
		Services,
		Faq,
		// Testimonials
	},
};
</script>

<style lang="scss"></style>
